import { useParams } from "react-router-dom";
import { Tabs } from "antd";
import DocumentsTab from "./tabs/DocumentsTab";
import CertificatesTab from "./tabs/CertificatesTab";
import FeedbackTab from "./tabs/FeedbackTab";
import TendersTab from "./tabs/TendersTab";
import ContractsTab from "./tabs/ContractsTab";

export default function DocumentsPage() {
  const { companyId } = useParams<{ companyId: string }>();
  const cid = Number(companyId);

  const items = [
    { key: "docs", label: "Documents", children: <DocumentsTab cid={cid} /> },
    { key: "certs", label: "Certificates", children: <CertificatesTab cid={cid} /> },
    { key: "feedback", label: "Client Feedback", children: <FeedbackTab cid={cid} /> },
    { key: "tenders", label: "Tenders", children: <TendersTab cid={cid} /> },
    { key: "contracts", label: "Contracts", children: <ContractsTab cid={cid} /> },
  ];

  return (
    <div>
      <div className="mb-4">
        <h1 className="text-xl font-bold text-slate-800">Documents & Contracts</h1>
        <p className="text-slate-500 text-sm">Company ID: {cid}</p>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-4">
        <Tabs items={items} size="small" />
      </div>
    </div>
  );
}
